import { fromJS } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { List } from 'foundations-components/transitional/components/List';
import useFetchPropertyLabels from 'reporting-data/hooks/useFetchPropertyLabels';
import useFilterInvalidFilterProperties from 'reporting-data/hooks/useFilterInvalidFilterProperties';
import { getDataTypeFromConfig } from 'reporting-data/report/reportGetters';
import { isUnifiedEventsReport } from 'reporting-data/tsTypes/reportTypes';

// @ts-expect-error Untyped import
import { ConditionalLabel, Label } from './Label';
import { StandardInlineLabel } from './labelComponents/StandardInlineLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdditionalFiltersTooltipContent = ({
  config
}) => {
  const filterProperties = useFilterInvalidFilterProperties(config);
  const propertyLabels = useFetchPropertyLabels(getDataTypeFromConfig(config), filterProperties);
  if (filterProperties.size === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.additionalFilters.tooltip.header"
      })
    }), /*#__PURE__*/_jsx(List, {
      styled: true,
      wrapChildren: true,
      paddingInlineStart: "400",
      children: propertyLabels.toList()
    })]
  });
};
export const condition = ({
  config
}) => config && !isUnifiedEventsReport(fromJS({
  config
})) && config.getIn(['filters', 'custom'], null) && !!config.getIn(['filters', 'custom']).size;
export const render = Label(({
  config
}) => {
  const filterProperties = useFilterInvalidFilterProperties(config);
  const numberOfFilters = filterProperties.size;
  const toolTipContent = /*#__PURE__*/_jsx(AdditionalFiltersTooltipContent, {
    config: config
  });
  if (!numberOfFilters) {
    return null;
  }
  return /*#__PURE__*/_jsx(StandardInlineLabel, {
    tooltipProps: {
      title: numberOfFilters ? toolTipContent : null,
      disabled: !toolTipContent
    },
    inlineLabelBadgeText: /*#__PURE__*/_jsx(FormattedMessage, {
      options: {
        count: numberOfFilters
      },
      message: "settingLabels.additionalFilters.inlineLabel"
    }),
    dataTestId: "inline-additional-filters-label"
  });
});
export const renderWithCondition = ConditionalLabel(condition, render);